export const setOffsetsOnScrollAT = Object.freeze({
    update: "update/setOffsetsOnScroll",
    setUp: "setUp/setOffsetsOnScroll",
});
